import {Stack, styled} from '@mui/material';
import {media} from '@contentlab/styles/mediaQueries';

const ResponsiveStack = styled(Stack)(() => ({
  gap: '12px',
  width: '40vw',
  height: '100%',

  [media.mobile]: {
    width: '100%',
  },
}));

export default ResponsiveStack;
